var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRectDots = function SvgRectDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 130 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 34.3359,
    width: 8.92667,
    height: 8.92667,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.1641,
    y: 34.3359,
    width: 8.92667,
    height: 8.92667,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.3359,
    y: 34.3359,
    width: 8.92667,
    height: 8.92667,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 34.3359,
    width: 8.92667,
    height: 8.92667,
    fill: "currentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 68.6641,
    y: 34.3359,
    width: 8.92667,
    height: 8.92667,
    fill: "currentColor"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8359,
    y: 34.3359,
    width: 8.92667,
    height: 8.92667,
    fill: "currentColor"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 34.3359,
    width: 8.92667,
    height: 8.92667,
    fill: "currentColor"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 120.164,
    y: 34.3359,
    width: 8.92667,
    height: 8.92667,
    fill: "currentColor"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 17.1641,
    width: 8.92667,
    height: 8.92667,
    fill: "currentColor"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 17.1641,
    y: 17.1641,
    width: 8.92667,
    height: 8.92667,
    fill: "currentColor"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 34.3359,
    y: 17.1641,
    width: 8.92667,
    height: 8.92667,
    fill: "currentColor"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 17.1641,
    width: 8.92667,
    height: 8.92667,
    fill: "currentColor"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 68.6641,
    y: 17.1641,
    width: 8.92667,
    height: 8.92667,
    fill: "currentColor"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8359,
    y: 17.1641,
    width: 8.92667,
    height: 8.92667,
    fill: "currentColor"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 17.1641,
    width: 8.92667,
    height: 8.92667,
    fill: "currentColor"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 120.164,
    y: 17.1641,
    width: 8.92667,
    height: 8.92667,
    fill: "currentColor"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 34.3359,
    width: 8.92667,
    height: 8.92667,
    fill: "currentColor"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    width: 8.92667,
    height: 8.92667,
    fill: "currentColor"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 68.6641,
    width: 8.92667,
    height: 8.92667,
    fill: "currentColor"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8359,
    width: 8.92667,
    height: 8.92667,
    fill: "currentColor"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    width: 8.92667,
    height: 8.92667,
    fill: "currentColor"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 120.164,
    width: 8.92667,
    height: 8.92667,
    fill: "currentColor"
  })));
};
export default SvgRectDots;